const KEY = 'workflow:create-source';
type IntentStorage = Pick<Storage, 'setItem' | 'getItem' | 'removeItem'>;

/** Retain the new Method page across the same-tab login redirect. */
export function saveCreateIntent(storage: IntentStorage, pathname: string, search: string): void {
  try {
    storage.removeItem(KEY);
    if (pathname.replace(/\/+$/, '') === '/new') storage.setItem(KEY, 'new');
  } catch { /* Sign-in remains available when session storage is blocked. */ }
}

export function consumeCreateIntent(storage: IntentStorage): string | null {
  try {
    const source = storage.getItem(KEY);
    storage.removeItem(KEY);
    return source === 'new' ? '/new' : null;
  } catch { return null; }
}
